import { render, staticRenderFns } from "./v5.vue?vue&type=template&id=6d19fd64&scoped=true"
import script from "./v5.vue?vue&type=script&lang=js"
export * from "./v5.vue?vue&type=script&lang=js"
import style0 from "./v5.vue?vue&type=style&index=0&id=6d19fd64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d19fd64",
  null
  
)

export default component.exports